import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    reasonField: {
        backgroundColor: 'white',
        width: '90%',
        margin: '10px 0'
    }
}));

export default useStyles;